<div class="panel-group" id="accordion">
  <app-report-detail-section [section]="'Activity'" [title]="'Activity list'" [allExpandState]="allExpandState">
  </app-report-detail-section>
  <div #section id="Activity" class="panel-collapse collapse">
    <div class="panel-body">
      @if ((activityLog$ | async).error) {
        <p class="errorText">{{ (activityLog$ | async).error }}</p>
      }
      <app-aa-spinner [loading]="(activityLog$ | async).isLoading"></app-aa-spinner>
      @if (!(activityLog$ | async).isLoading && !(activityLog$ | async).error && activityLogList) {
      <div class="table-fixed-height">
        <table class="reportHistory-table table table-hover table-striped" style="width:100%;">
          <thead>
            <tr>
              @for (column of dtOptions.columns; track column) {
              <th>
                {{column.title}} </th>
              }
            </tr>
          </thead>
          <tbody>
            @for (rpa of activityLogList; track rpa) {
            <tr>
              <td>{{rpa.createDate | date : "MM/dd/yyyy hh:mm a" : 'UTC'}} </td>
              <td>{{rpa.firstName}} {{rpa.lastName}}</td>
              <td>{{rpa.employeeId}}</td>
              <td>{{rpa.station}}</td>
              <td>{{rpa.department}}</td>
              <td>{{rpa.jobTitle}}</td>
              <td>{{rpa.profileDesc}}</td>
              <td>{{rpa.action}}</td>
            </tr>
            }
          </tbody>
        </table>
      </div>
      }
      @if (additionalEmailList && additionalEmailList.length > 0) {
        <div>
          <h3>Additional Emails</h3>
          <table class="reportHistory-table table table-hover table-striped" style="width:100%;">
            <thead>
              <tr>
                @for (column of additionalEmaiOptions.columns; track column) {
                  <th>
                  {{column.title}} </th>
                }
              </tr>
            </thead>
            <tbody>
              @for (rpa of additionalEmailList; track rpa) {
                <tr>
                  <td>{{rpa.createDate | date : "MM/dd/yyyy hh:mm a" : 'UTC'}} </td>
                  <td>{{rpa.additionalEmail}}</td>
                  <td>{{rpa.action}}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    </div>
  </div>
</div>
